import React from 'react';
import ReactDOM from 'react-dom';
import App from "../App";

/**
 * 渲染子应用
 */

export default function render({ loading }) {
  const container = document.getElementById('root');
  ReactDOM.render(<App/>, container);
}
